import type React from "react";
import { ReactComponent as Svg } from "./assets/casino/rakeback-chips.svg";
import * as styles from "./Icon.module.scss";

type RakebackChipsProps = React.SVGProps<SVGSVGElement>;

export const RakebackChips = ({ className, ...props }: RakebackChipsProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
